import * as React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Drawer from "@mui/material/Drawer";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import {
  Col,
  Row,
  FormGroup,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  InputGroup,
  FormFeedback,
  FormText,
} from "reactstrap";
import InputLabel from "@mui/material/InputLabel";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PDF from "../../pdfGenerate/pdf";
import RemedyPDF from "../../pdfGenerate/remedypdf";

export default function CustomizedDialogs(props) {
  const {
    selected,
    itemgroupselected,
    component,
    cisresult,
    overallAudit,
    failedAudit,
    hostname,
    ipdns,
    platform,
    exedate,
    passedaudit,
    skippedAudit,
  } = props;

  const Submit = (selected) => (e) => {
    e.preventDefault();
    let sub = {
      host_id: window.sessionStorage.getItem("hostID").toString(),
      remedy_id: window.sessionStorage.getItem("remedyID").toString(),
      tags: selected.toString(),
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/run_rollback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(sub),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.detail);
        window.location.href = "/admin/rollback";
      })
      .catch((error) => {
        console.log(error);
        window.location.href = "/admin/rollback";
      });
    window.location.href = "/admin/rollback";
  };
  return (
    <>
      <button
        className="bg-blueGray-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        <Link
          to={{
            pathname: "/admin/remedy",
          }}
          style={{ color: "#FFF" }}
        >
          <i className="mr-2 text-x">
            <ArrowBackIosIcon size="small" fontSize="small" />
          </i>
          Back
        </Link>
      </button>
      <RemedyPDF
        component={component}
        cisresult={cisresult}
        overallAudit={overallAudit}
        failedAudit={failedAudit}
        hostname={hostname}
        ipdns={ipdns}
        platform={platform}
        exedate={exedate}
        passedaudit={passedaudit}
        skippedAudit={skippedAudit}
      />      
      <PDF
        component={component}
        cisresult={cisresult}
        overallAudit={overallAudit}
        failedAudit={failedAudit}
        hostname={hostname}
        ipdns={ipdns}
        platform={platform}
        exedate={exedate}
        passedaudit={passedaudit}
        skippedAudit={skippedAudit}
      />
      <button
        disabled={
          selected.length > 0 || itemgroupselected.length > 0 ? false : true
        }
        className={
          selected.length > 0 || itemgroupselected.length > 0
            ? "bg-lightBlue-500  text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            : "bg-blueGray-200  text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        }
        type="button"
        style={{ float: "right" }}
        onClick={Submit(selected)}
      >
        {selected.length > 0 || itemgroupselected.length > 0 ? (
          <i className="mr-2 text-x">
            <CheckBoxIcon size="small" fontSize="small" />
          </i>
        ) : (
          <i className="mr-2 text-x">
            <CheckBoxOutlineBlankIcon size="small" fontSize="small" />
          </i>
        )}
        Rollback Selected
      </button>
    </>
  );
}
